/**
 * With Redux, there is only a SINGLE STORE. Properties and mutations of the
 * store are managed by reducers. This file sets up the store, and hydrates
 * the store with reducers.
 * @flow
 */

import { createStore, applyMiddleware, compose } from 'redux'
import reducer from '../reducers'
import middlewares from '../middlewares'
import serverProps from '../utils/serverProps'

// if you have the Redux DevTools extension installed then this will start that
// otherwise Redux' compose will be used.
// https://chrome.google.com/webstore/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd/related?hl=en
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

// create a store, and apply middleware
type ReduxStore = {
  dispatch: (action: { type: string, data?: any }) => void,
  getState: () => Object,
}

const enhancer = composeEnhancers(applyMiddleware(...middlewares))
const store: ReduxStore = createStore(reducer, enhancer)

// expose the store for Cypress for non-production environment
if (!serverProps.isProduction && window.Cypress) {
  window.store = store
}
export default store
